import React from "react";
import styled from "styled-components";

//icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faShoppingCart} from  '@fortawesome/pro-light-svg-icons'

const IconoEnCarrito = () => {
  //className="icono-ya-en-carrito" data-prod-id={tendencia.id}
  return (
    <IconoYaEnCarrito title="Ya en tu carrito">
        <FontAwesomeIcon icon={faShoppingCart}/> 
    </IconoYaEnCarrito>
  );
};
const IconoYaEnCarrito = styled.div`
  color: white;
  background-color: ${(props) => props.theme.primarioHover};
  border: thin solid ${(props) => props.theme.primarioHover};
  border-radius: 100px;
  position: absolute;
  z-index: 1;
  left: 50%;
  margin-left: -20px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default IconoEnCarrito;
